import { styles, SkeletonTheme } from '../SkeletonStyles.css';
import { baseTheme } from './SkeletonBaseTheme.css';
import { multiVariantStyles } from './SkeletonVariants.css';

const SkeletonStableTheme: SkeletonTheme = {
  baseTheme,
  multiVariantStyles,
  styles
};

/*******************
 * Exports
 *******************/

export { SkeletonStableTheme };
